/**
 * Per-viewer active space. The space lives in the URL (?space=<id>) so a view is
 * shareable; localStorage just remembers the last choice to seed the default on
 * a fresh visit. No server state — each viewer picks their space independently.
 */
const KEY = "greenlight.activeSpace";

export function rememberedSpace(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function rememberSpace(id: string): void {
  try {
    localStorage.setItem(KEY, id);
  } catch {
    // private mode / storage disabled — the URL still carries the space.
  }
}

/**
 * Pick the space to show when the URL doesn't name one: the remembered choice if
 * it still has tasks, else the first available space. `null` = nothing to pick
 * yet (no spaces loaded).
 */
export function resolveDefaultSpace(spaces: { id: string }[]): string | null {
  if (spaces.length === 0) return null;
  const remembered = rememberedSpace();
  if (remembered && spaces.some((s) => s.id === remembered)) return remembered;
  return spaces[0]!.id;
}
